// TSS vite/05 — session helpers.
//
// With the cookie+CSRF transport, the session JWT lives in an httpOnly
// cookie that JS cannot read. The only JS-readable token is csrf_token,
// which the api interceptor needs on every mutating request.
//
// The cookie is set by the backend on /auth/login and cleared on /auth/logout.

const CSRF_COOKIE = 'csrf_token';

export function readCsrfCookie() {
    const match = document.cookie.match(new RegExp(`(?:^|; )${CSRF_COOKIE}=([^;]*)`));
    return match ? decodeURIComponent(match[1]) : null;
}

// Forces every other tab to log out. The interceptor (or AuthProvider)
// flips this key when it detects a 401 or after a /auth/logout call.
// Per TSS vite/05 §"Logout-everywhere and session invalidation".
export function broadcastLogout() {
    try {
        localStorage.setItem('logout_signal', String(Date.now()));
    } catch {
        // localStorage may be unavailable (private mode, quota); ignore.
    }
}
